function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 33,
  r: 30,
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: 6,
  className: "spinner-path"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "65px",
    height: "65px",
    className: "spinner",
    viewBox: "0 0 66 66"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/material-spinner.434df929.svg";
export { SvgComponent as ReactComponent };